<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-size-25"></div>
      <div class="md-layout-item md-medium-size-100 md-size-50">
        <NuevaSena
          data-background-color="green"
          class="justify-center"
        ></NuevaSena>
      </div>
      <div class="md-layout-item md-medium-size-100 md-size-25"></div>
    </div>
  </div>
</template>

<script>
import NuevaSena from "../components/Sena/NuevaSena.vue";

export default {
  components: {
    NuevaSena
  }
};
</script>
